<div flex>
  <p class="mat-body-2">Monitor student absences across supports in the Support Attendance page.</p>
  <button class="step-action-button" mat-raised-button (click)="goToSupportsSettings()">View Support Attendance</button>
</div>